export function formatDate(date: Date, niceFormat = false) {
  let day = String(date.getUTCDate())
  const year = String(date.getUTCFullYear())
  if (niceFormat) {
    return `${day} ${date.toLocaleDateString("en-US", {
      month: "short",
    })}, ${year}`
  }
  let month = String(date.getUTCMonth() + 1)

  if (month.length < 2) {
    month = `0${month}`
  }
  if (day.length < 2) {
    day = `0${day}`
  }

  return [year, month, day].join("-")
}
